export const SCREEN = window.screen
export const SCALE = 1.1
